import type { TOC } from '@ember/component/template-only';

import BoardBoardOrLoopPreviewComponent from 'webapp/components/board/board-or-loop-preview';
import type BoardsViewBoardController from 'webapp/controllers/boards/view/board';

interface Args {
	controller: BoardsViewBoardController;
}

const BoardsViewBoardRouteTemplate: TOC<Args> = <template>
	<div id="datawall">
		<BoardBoardOrLoopPreviewComponent
			@board={{@controller.model}}
			@previewMap={{@controller.previewMap}}
			@updatePreviewMap={{@controller.updatePreviewMap}}
			@onVisibleBoardChange={{@controller.updateBoardIdParam}}
		/>
	</div>
</template>;

export default BoardsViewBoardRouteTemplate;
